// extracted by mini-css-extract-plugin
module.exports = {"card":"TwoDimensionsChart_card__bhjWY","placeholder":"TwoDimensionsChart_placeholder__1Dv4_","noData":"TwoDimensionsChart_noData__uOWif"};